



























import { Component, Vue, Prop } from 'vue-property-decorator';
import MealService from '../../services/MealService';

@Component
export default class SaveAsMealForm extends Vue {
  private valid: boolean = false;
  private loading: boolean = false;
  private name: string = '';
  private description: string = '';

  private async createMeal() {
    if (this.mealFood && this.mealFood.length > 0) {
      try {
        const response = await MealService.createMeal(this.mealFood,
          {description: this.description, name: this.name});
        const rows = response.data;
        const meal = rows[0];
        this.$store.dispatch('addMeal', {id: meal.id, description: this.description, name: this.name});
        this.$emit('snackbar', 'Meal created!', 'blue-grey');
      } catch (e) {
        this.$emit('snackbar', e.message, 'error');
      } finally {
        this.$emit('update:dialog', false);
      }
    } else {
      this.$emit('snackbar', 'No ingredients to save', 'error');
    }
  }

  get mealFood() {
    return this.$store.getters.getMealFood;
  }
}
